import { createContext, useContext } from 'react';

import type { Schemas } from '@/api/client';

export type AppConfig = Schemas['PublicConfigOut'];

export const ConfigContext = createContext<AppConfig | null>(null);

export function useAppConfig(): AppConfig {
  const config = useContext(ConfigContext);
  if (!config) throw new Error('useAppConfig must be used inside AppConfigProvider');
  return config;
}
